import { StocktakingResponse } from '../../services/api';
import { amsLegacyService } from '../../services';
import { useAsync } from '.';

/**
 *
 * @deprecated
 */
const useStocktaking = (id?: number) => {
  const { data, setData, loading, setParameters } = useAsync<StocktakingResponse | null>(
    amsLegacyService.getStocktaking,
    null,
    id ? [id] : null
  );

  return {
    stocktaking: data,
    setStocktaking: setData,
    loading,
    setParameters
  };
};

export default useStocktaking;
